// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"7c5c94af","545":"a5b4777a","551":"a22a53b6","605":"a92e54b2","662":"4afa1eb6","766":"53b15989"}[chunkId] + ".chunk.js";
};